

































import { Component, Vue } from 'vue-property-decorator';
import { Actions } from '@/ts/store/Constants';
import IdentityData from '@/ts/IdentityData';
import AccountSwitcherItem from '@/components/DropDowns/AccountSwitcher/AccountSwitcherItem.vue';

@Component({
    components: {
        AccountSwitcherItem,
    },
})
export default class AccountSwitcherDropDown extends Vue {
    public showDropDown: boolean = false;

    constructor() {
        super();
    }

    get selectedIdentity(): IdentityData {
        return this.$store.getters['Identities/getSelectedIdentity'];
    }

    get identities(): IdentityData[] {
        return this.$store.getters['Identities/getIdentities'].filter((identity: IdentityData) => {
            return !identity.isTheSameIdentity(this.selectedIdentity);
        });
    }

    public switchIdentity(identity: IdentityData) {
        this.showDropDown = false;

        this.$store.dispatch(Actions.HIDE_SHELF).then(() => {
            this.$store.dispatch(Actions.SWITCH_IDENTITY, {vue: this, identity});
        });
    }
}
